import { ConsumptionOmie, IConsumptionsOmiePayload, OmieWeekly, PriceOmie } from "@edp-models/consumptions-omie.model";
import { Action } from "@ngrx/store";

export enum EConsumptionOmieActions {
    GetOmieWeeklyAverage = "[ConsumptionsOmie] Get Omie Weekly Average",
    SetOmieWeeklyAverage = "[ConsumptionsOmie] Set Omie Weekly Average",
    GetOmieConsumption = "[ConsumptionsOmie] Get Omie Consumption",
    SetOmieConsumption = "[ConsumptionsOmie] Set Omie Consumption",
    GetOmiePrice = "[ConsumptionsOmie] Get Omie Price",
    SetOmiePrice = "[ConsumptionsOmie] Set Omie Price",
}

export class GetOmieWeeklyAverage implements Action {
    public readonly type = EConsumptionOmieActions.GetOmieWeeklyAverage;
}

export class SetOmieWeeklyAverage implements Action {
    public readonly type = EConsumptionOmieActions.SetOmieWeeklyAverage;
    constructor(public payload: OmieWeekly) {}
}

export class GetOmieConsumption implements Action {
    public readonly type = EConsumptionOmieActions.GetOmieConsumption;
    constructor(public payload: IConsumptionsOmiePayload) {}
}

export class SetOmieConsumption implements Action {
    public readonly type = EConsumptionOmieActions.SetOmieConsumption;
    constructor(public payload: ConsumptionOmie) {}
}

export class GetOmiePrice implements Action {
    public readonly type = EConsumptionOmieActions.GetOmiePrice;
}

export class SetOmiePrice implements Action {
    public readonly type = EConsumptionOmieActions.SetOmiePrice;
    constructor(public payload: PriceOmie) {} //PriceOmie
}

// export class ConsumptionsAPIError implements Action {
//     public readonly type = EConsumptionOmieActions.ConsumptionsAPIError;
//     constructor(public error: Error) {}
// }

export type ConsumptionOmieActions =
    | GetOmieWeeklyAverage
    | SetOmieWeeklyAverage
    | GetOmieConsumption
    | SetOmieConsumption
    | GetOmiePrice
    | SetOmiePrice;
